import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_FORMATS,
} from '@angular/material-moment-adapter';
import * as moment from 'moment';

export const MONTH_YEAR_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MMMM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'MMMM YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-export-month-year-dialog',
  templateUrl: './export-month-year-dialog.component.html',
  styleUrls: ['./export-month-year-dialog.component.css'],
  providers: [
    //  Provide Moment adapter locally (only for this component)
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MONTH_YEAR_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
  ],
})
export class ExportMonthYearDialogComponent implements OnInit {
  dateForm!: FormGroup;
  chosenYear!: number;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ExportMonthYearDialogComponent>
  ) { }

  ngOnInit(): void {
    const currentDate = moment(); // current month-year
    this.dateForm = this.fb.group({
      monthYear: [currentDate],
    });
  }

  // When user clicks a year
  chosenYearHandler(normalizedYear: moment.Moment) {
    this.chosenYear = normalizedYear.year();
  }

  // When user clicks a month
  chosenMonthHandler(normalizedMonth: moment.Moment, datepicker: any) {
    const ctrlValue = this.dateForm.value.monthYear;
    ctrlValue.year(this.chosenYear || ctrlValue.year());
    ctrlValue.month(normalizedMonth.month());
    this.dateForm.patchValue({ monthYear: ctrlValue });
    datepicker.close();
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onExport(): void {
    const selectedDate: moment.Moment = this.dateForm.value.monthYear;
    const year = selectedDate.year();
    const month = selectedDate.month() + 1;
    this.dialogRef.close({ month, year });
  }
}
